import PropTypes from 'prop-types';
import getNoDataCellComponent from '../../../Common/NoDataCellComponent';
import styles from './styles';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { CONFIRM_DIALOG, JOB_PROFILE_DIALOG } from '../../../../redux/constants/dialogs';
import ViewListIcon from '@material-ui/icons/ViewList';
import Grid from '../../../Common/Grid';
import StageChip from './StageChip';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

const COLUMNS = [
  { name: 'name', title: 'Name' },
  { name: 'stages', title: 'Stages' },
  { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'name', width: 230 },
  { columnName: 'action', width: 50 },
];

const getCellComponent = ({ row, column, value }) => {
  switch (column.name) {
    case 'stages':
      return (<div style={styles.stages}>
        {(value || []).map((stage, idx) => (<StageChip key={stage.id} stage={stage} order={idx + 1}/>))}
      </div>);
    case 'action':
      return null;
    default:
      return value;
  }
};

class JobProfilesGrid extends React.Component {

  handleAdd = () => {
    this.props.showDialog(JOB_PROFILE_DIALOG, { profile: {} });
  };

  handleEdit = (profile) => {
    this.props.showDialog(JOB_PROFILE_DIALOG, { profile });
  };

  handleRemove = (profile) => {
    return new Promise((resolve, reject) => {
      this.props.showDialog(CONFIRM_DIALOG, {
        title: 'Are you sure you wish to remove this job profile?',
        onConfirm: () => {
          this.props.onRemove(profile)
            .then(resolve);
        },
        onReject: reject,
        confirmColor: 'secondary',
      });
    });
  };

  render() {
    const { data, fetch } = this.props;

    const buttons = [<Tooltip key="create" title="Add Customer">
      <Fab
        color="secondary"
        aria-label="add"
        style={styles.add}
        onClick={this.handleAdd}
        id="add"
      >
        <AddIcon/>
      </Fab>
    </Tooltip>];

    return (<Grid
      buttons={buttons}
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      cellComponent={getCellComponent}
      data={data}
      fetch={fetch}
      onEdit={this.handleEdit}
      onRemove={this.handleRemove}
      noDataCellComponent={getNoDataCellComponent(<ViewListIcon style={styles.noData}/>, 'job profiles')}
    />);
  }
}

JobProfilesGrid.propTypes = {
  data: PropTypes.object,
  fetch: PropTypes.func.isRequired,
  showDialog: PropTypes.func,
};

export default JobProfilesGrid;



// WEBPACK FOOTER //
// ./src/components/Admin/JobProfiles/JobProfilesGrid/index.js